export type AuthInterruptionReason = 'ip_allowlist_violation' | 'session_expired'

let authInterruptionReason: AuthInterruptionReason | null = null

export function getAuthInterruption(): AuthInterruptionReason | null {
  return authInterruptionReason
}

export function setAuthInterruption(reason: AuthInterruptionReason): void {
  authInterruptionReason = reason
}

export function clearAuthInterruption(): void {
  authInterruptionReason = null
}
